import { useTranslation } from "@shared/utils/internationalization";
import { Box, Flex, Text } from "@chakra-ui/react";
import CloseButton from "@shared/components/ui-kit/form/CloseButton/CloseButton.web";
import CDNImage from "../../media/CDNImage/CDNImage.web";
import { RemoveDocumentButtonProps } from "./RemoveDocumentButton.props";

const RemoveDocumentButton = (
  props: RemoveDocumentButtonProps
): JSX.Element => {
  const { customIcon, src, aspectRatio, title, subTitle, onClick } = props;
  const { t } = useTranslation("common");

  return (
    <Flex
      width="100%"
      alignItems="center"
      justifyContent="space-between"
      boxSizing="border-box"
      backgroundColor="gray.200"
      border="1px solid"
      borderColor="gray.300"
      borderRadius="sm"
      lineHeight="0px"
      padding="xs"
    >
      <Flex alignItems="center" justifyContent="space-between">
        {customIcon || (
          // use the upload aspect ratio to display preview that is representative of the image that will be displayed.
          <CDNImage
            src={src}
            width={60 * aspectRatio}
            height={60}
            alt={t("Image preview")}
            style={{ borderRadius: "2xs" }}
          />
        )}
        <Box marginLeft="xl" lineHeight="22px">
          <Text fontSize="sm" fontWeight="bold">
            {title}
          </Text>
          <Text fontSize="sm" color="gray.600">
            {subTitle}
          </Text>
        </Box>
      </Flex>
      <CloseButton size="md" color="font.dark" onClick={onClick} />
    </Flex>
  );
};

export default RemoveDocumentButton;
